import Model from "@/components/common/model.component";
import FertigatorsFrom from "./FertigatorsFrom";
import PageTitle from "components/common/page-title.component";

export default function AddFertigators(props) {
  const { showModalFertigators, setShowModalFertigators, label, setRowData } =
    props;
  return (
    <Model
      width="w-[65rem]"
      show={showModalFertigators}
      onClose={(e) => {
        setShowModalFertigators(false);
        setRowData({});
      }}
    >
      <PageTitle title={label} titletextSize="text-xl" />
      {Object.keys(props.rowData).length > 0 && (
        <FertigatorsFrom
          rowData={props.rowData}
          setShowModalFertigators={setShowModalFertigators}
          defaultValues={props.rowData}
        />
      )}
    </Model>
  );
}
